<template>
  <v-row class="mx-auto d-flex mt-10">
    <div style="margin-left: 10%; min-width: 80%">
      <v-form ref="formUpdate">
        <v-row>
          <v-col cols="12" class="d-flex" md="6">
            <v-text-field
            :class="this.mdAndUp ? 'mt-2' : ''"
            style="width: 100%"
            clearable
            clear-icon="mdi-close"
            label="Nome"
            v-model="registroEdit.nome"
            required
            :rules="[
              (val) =>
                (RegExp(
                  '^[A-Za-z0-9-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ,.()\n ]*$',
                ).test(val) &&
                  !RegExp('[ ]{2,}').test(val)) ||
                'Nome Inválido, verifique espaçamento e caracteres',
              (val) => val != '' || 'Insira seu nome',
              (val) => val != null || 'Insira seu nome',
              (val) => val != undefined || 'Insira seu nome',
            ]"
            :disabled="!edit[0]"
            variant="underlined"
            color="red">
          </v-text-field>
          <p
            v-if="!edit[0]"
            :class="mdAndUp ? 'text-h6 ' : 'text-body-2'"
            style="margin-top: 26px"
          >
            <v-icon class="ml-2" @click="edit[0] = true" size="x-small"
              >mdi-pencil-outline</v-icon
            >
          </p>
          </v-col>
          <v-col cols="12" class="d-flex" md="6">
            <v-text-field
              :class="this.mdAndUp ? 'mt-2' : ''"
              style="width: 100%"
              clearable
              clear-icon="mdi-close"
              label="Sobrenome"
              v-model="registroEdit.sobrenome"
              required
              :rules="[
                (val) =>
                  (RegExp(
                    '^[A-Za-z0-9-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ,.()\n ]*$',
                  ).test(val) &&
                    !RegExp('[ ]{2,}').test(val)) ||
                  'Sobrenome Inválido, verifique espaçamento e caracteres',
                (val) => val != '' || 'Insira seu sobrenome',
                (val) => val != null || 'Insira seu sobrenome',
                (val) => val != undefined || 'Insira seu sobrenome',
              ]"
              variant="underlined"
              color="red"
              :disabled="!edit[1]"
            >
            </v-text-field>
            <p
              style="margin-top: 26px"
              v-if="!edit[1]"
              :class="mdAndUp ? 'text-h6' : 'text-body-2'"
            >
              <v-icon class="ml-2" @click="edit[1] = true" size="x-small"
                >mdi-pencil-outline</v-icon
              >
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex" md="6">
            <v-text-field
              :class="this.mdAndUp ? 'mt-2' : ''"
              style="width: 100%"
              clearable
              clear-icon="mdi-close"
              label="Telefone"
              v-model="registroEdit.telefone"
              variant="underlined"
              color="red"
              counter
              placeholder="(99) 9999-99999"
              maxlength="15"
              minlength="14"
              required
              :rules="[
                (val) => val != null || 'Digite seu número de telefone',
                (val) => val != '' || 'Digite seu número de telefone',
                (val) => val != undefined || 'Digite seu número de telefone',
                (val) => val.length >= 14 || 'Número inválido',
              ]"
              :disabled="!edit[2]"
            >
            </v-text-field>
            <p
              style="margin-top: 26px"
              v-if="!edit[2]"
              :class="mdAndUp ? 'text-h6' : 'text-body-2'"
            >
            <v-icon class="ml-2" @click="edit[2] = true" size="x-small"
                >mdi-pencil-outline</v-icon
              >
            </p>
          </v-col>
          <v-col cols="12" class="d-flex" md="6">
            <v-text-field
              :class="this.mdAndUp ? 'mt-2' : ''"
              style="width: 100%"
              clearable
              clear-icon="mdi-close"
              label="Cep (somente números)"
              v-model="registroEdit.cep"
              required
              :rules="[
                (val) => val != '' || 'Insira seu cep',
                (val) => val != null || 'Insira seu cep',
                (val) => val != undefined || 'Insira seu cep',
                (val) => val.length == 9 || 'Cep inválido',
              ]"
              variant="underlined"
              color="red"
              :disabled="!edit[3]"
            >
            </v-text-field>
            <p
              style="margin-top: 26px"
              v-if="!edit[3]"
              :class="mdAndUp ? 'text-h6' : 'text-body-2'"
            >
            <v-icon class="ml-2" @click="edit[3] = true" size="x-small"
                >mdi-pencil-outline</v-icon
              >
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex" md="8">
            <v-text-field
              :class="this.mdAndUp ? 'mt-2' : ''"
              style="width: 100%"
              clearable
              clear-icon="mdi-close"
              label="Endereco"
              v-model="registroEdit.endereco"
              required
              :rules="[
                (val) =>
                  (RegExp(
                    '^[A-Za-z0-9-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ,.()\n ]*$',
                  ).test(val) &&
                    !RegExp('[ ]{2,}').test(val)) ||
                  'Endereco Inválido, verifique espaçamento e caracteres',
                (val) => val != '' || 'Insira seu Endereco',
                (val) => val != null || 'Insira seu Endereco',
                (val) => val != undefined || 'Insira seu Endereco',
              ]"
              variant="underlined"
              color="red"
              :disabled="!edit[4]"
            >
            </v-text-field>
            <p
              style="margin-top: 26px"
              v-if="!edit[4]"
              :class="mdAndUp ? 'text-h6' : 'text-body-2'"
            >
            <v-icon class="ml-2" @click="edit[4] = true" size="x-small"
                >mdi-pencil-outline</v-icon
              >
            </p>
          </v-col>
          <v-col cols="12" class="d-flex" md="4">
            <v-text-field
              :class="this.mdAndUp ? 'mt-2' : ''"
              style="width: 100%"
              clearable
              clear-icon="mdi-close"
              label="Número"
              v-model="registroEdit.numero"
              required
              :rules="[
                    (val) => val != '' || 'Insira o número',
                    (val) => val != null || 'Insira o número',
                    (val) => val != undefined || 'Insira o número',
                    (val) => /^[a-zA-Z0-9 .]*$/.test(val) || 'Número Inválido',
                    !RegExp('[ ]{2,}').test(val) || 'Número Inválido',
                    (val) => val.length <= 8 || 'Número inválido',
                  ]"
              variant="underlined"
              color="red"
              :disabled="!edit[6]"
            >
            </v-text-field>
            <p
              style="margin-top: 26px"
              v-if="!edit[6]"
              :class="mdAndUp ? 'text-h6' : 'text-body-2'"
            >
            <v-icon class="ml-2" @click="edit[6] = true" size="x-small"
                >mdi-pencil-outline</v-icon
              >
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex" md="6">
            <v-text-field
              :class="this.mdAndUp ? 'mt-2' : ''"
              style="width: 100%"
              clearable
              clear-icon="mdi-close"
              label="Complemento (Se não necessitar, deixar vazio)"
              v-model="registroEdit.complemento"
              required
              :rules="[
                (val) => val != null || 'Insira o complemento',
                (val) => val != undefined || 'Insira o complemento',
                (val) => /^[a-zA-Z0-9 .]*$/.test(val) || 'Complemento Inválido',
                !RegExp('[ ]{2,}').test(val) || 'Complemento Inválido',
              ]"
              variant="underlined"
              color="red"
              :disabled="!edit[7]"
            >
            </v-text-field>
            <p
              style="margin-top: 26px"
              v-if="!edit[7]"
              :class="mdAndUp ? 'text-h6' : 'text-body-2'"
            >
            <v-icon class="ml-2" @click="edit[7] = true" size="x-small"
                >mdi-pencil-outline</v-icon
              >
            </p>
          </v-col>
          <v-col cols="12" class="d-flex" md="6">
            <v-autocomplete
              :class="this.mdAndUp ? 'mt-2' : ''"
              style="width: 100%"
              clearable
              clear-icon="mdi-close"
              label="Bairro"
              v-model="registroEdit.bairro"
              required
              :rules="[
                (val) => val != null || 'Selecione um Bairro',
                (val) => val != '' || 'Selecione um Bairro',
              ]"
              variant="underlined"
              color="red"
              :items="bairros"
              :item-title="(item) => item.nome"
              :item-value="(item) => item"
              density="comfortable"
              max-height="50px"
              :disabled="!edit[5]"
            ></v-autocomplete>
            <p
              style="margin-top: 26px"
              v-if="!edit[5]"
              :class="mdAndUp ? 'text-h6' : 'text-body-2'"
            >
              <v-icon class="ml-2" @click="edit[5] = true" size="x-small"
                >mdi-pencil-outline</v-icon
              >
            </p>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </v-row>
  <v-col>
    <v-btn
      class="ml-5"
      v-if="edit.find((val) => val == true)"
      color="red"
      @click="
        (this.registroEdit = JSON.parse(JSON.stringify(this.logado.data))),
          (this.edit = [false, false, false, false, false, false]),
          (this.formValido = false)
      "
      >Cancelar</v-btn
    >
    <v-btn
      class="ml-5"
      color="green"
      :disabled="!formValido"
      @click="atualizaDados()"
      >Salvar</v-btn
    >
  </v-col>
</template>
<script>
import { mapGetters } from "vuex";
import { useDisplay } from "vuetify";
import updateUser from "../../libs/updateUser";
import { store } from "../../store/store";
import axios from "axios";
import stringSimilarity from "string-similarity";
import checkStatus from "../../libs/checkStatus";
import getDadosEmpresa from "../../libs/getDadosEmpresa";
import { maskJs } from "mask-js";

var image = require("../../assets/logowithtext.svg");

export default {
  name: "meusDados",
  data: () => ({
    empresas: [],
    registerLimit: 5,
    selectedEmpresa: null,
    empresasData: [],
    pedisosData: [],
    tab: "account",
    selectedPedidos: "Em Andamento",
    drawer: true,
    rail: true,
    floatingButton: false,
    edit: [false, false, false, false, false, false, false, false],
    formValido: false,
    items: [
      {
        title: "Meus Dados",
        value: 1,
        props: {
          prependIcon: "mdi-user",
        },
      },
      {
        title: "Acompanhamento",
        value: 2,
      },
    ],
    registroEdit: {
      endereco: "",
      bairro: "",
      cidade: "Passo Fundo",
      numero: "",
      complemento: "",
      nome: "",
      whatsapp: "",
      telefone: "",
      sobrenome: "",
    },
    image: image,
    teste: "",
  }),
  setup() {
    // Destructure only the keys we want to use
    const { xs, mdAndUp } = useDisplay();

    return { xs, mdAndUp };
  },
  watch: {
    teste(n) {
      console.log(n);
    },
    registroEdit: {
      handler() {
        this.$refs.formUpdate.validate().then((val) => {
          if (
            val.valid &&
            JSON.stringify(this.logado.data) !=
              JSON.stringify(this.registroEdit)
          ) {
            this.formValido = true;
          } else {
            this.formValido = false;
          }
        });
      },
      deep: true,
    },
    "logado.data": {
      handler() {
        this.registroEdit = JSON.parse(JSON.stringify(this.logado.data));
        this.registroEdit.cep = this.registroEdit.cep.replace(/\D/g, "");
      },
      deep: true,
    },
    async "registroEdit.cep"(n) {
      const cleanCep = n.replace(/\D/g, "");
      this.registroEdit.cep = maskJs("99999-999", n);
      if (cleanCep.length == 9 && this.edit[3] == true) {
        {
          const response = await axios({
            method: "get",
            url: `https://viacep.com.br/ws/${n}/json/`,
          });
          this.edit[4] = true;
          this.edit[5] = true;
          this.registroEdit.endereco = response.data.logradouro;
          this.registroEdit.bairro = this.matchBairro(response);
        }
      }
    },
    "registroEdit.telefone"(n) {
      const cleanedPhone = n.replace(/\D/g, "");
      if (cleanedPhone.length > 10) {
        this.registroEdit.telefone = maskJs("(99) 9 9999-9999", n);
      } else {
        this.registroEdit.telefone = maskJs("(99) 9999-9999", n);
      }
    },
  },

  computed: {
    visiblePedidos() {
      return this.pedidosData
        .filter((pedido) => pedido.empresa === this.selectedEmpresa)
        .sort((a, b) => b.num - a.num);
    },
    ...mapGetters([
      "selecionadoCategorias",
      "database",
      "dadosEmpresa",
      "carrinho",
      "pedidos",
      "produtos",
      "categorias",
      "horario",
      "busca",
      "disableDelivery",
      "disableEncomenda",
      "combos",
      "shownAlert",
      "bairros",
      "logado",
    ]),
  },
  methods: {
    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    onScroll() {
      this.floatingButton = window.scrollY > 0;
    },
    countPedidosByEmpresa(empresa) {
      return this.pedidosData.filter((pedido) => pedido.empresa === empresa)
        .length;
    },
    hasMorePedidos(selectedEmpresa) {
      const count = this.countPedidosByEmpresa(selectedEmpresa);
      return count > this.registerLimit;
    },
    increaseLimit() {
      this.registerLimit += 5; // Increase the limit by 10 (or adjust as needed)
    },
    manipulateDataEmAndamento() {
      const response = checkStatus();

      response.then((data) => {
        const empresas = new Set(); // Use a Set to store unique empresa values
        const empresasData = []; // Array to store the data for each empresa
        const pedidosData = [];

        // Iterate over the data and extract the empresa values
        data.data.result.data.forEach((item) => {
          empresas.add(item.empresa);
          pedidosData.push(item);
        });

        const empresasList = Array.from(empresas); // Convert the Set to an array

        // Fetch data for each empresa and populate the empresasData array
        empresasList.forEach((empresa) => {
          const dadosEmpresa = getDadosEmpresa(empresa, true); 
          empresasData.push(dadosEmpresa);
        });

        this.empresas = empresasList;
        this.empresasData = empresasData;
        this.pedidosData = pedidosData;
      });
    },

    matchBairro(response) {
      const bairroNames = this.bairros.map((bairro) => bairro.nome);
      const matches = stringSimilarity.findBestMatch(
        response.data.bairro,
        bairroNames,
      );

      const bestMatch = matches.bestMatch.target;
      const matchedBairro = this.bairros.find(
        (bairro) => bairro.nome === bestMatch,
      );

      return matchedBairro;
    },

    atualizaDados() {
      this.registroEdit.whatsapp =
        "55" + this.registroEdit.telefone.replace(/[() -]/g, "");

      updateUser(this.registroEdit).then((n) => {
        if (n.status == 200) {
          let updatedFields = n.data.data;
          let logado = this.logado;
          logado.data = {
            bairro: updatedFields.bairro,
            cidade: updatedFields.cidade,
            endereco: updatedFields.endereco,
            nome: updatedFields.nome,
            sobrenome: updatedFields.sobrenome,
            telefone: updatedFields.telefone,
            numero: updatedFields.numero,
            complemento: updatedFields.complemento,
            cep: updatedFields.cep,
            cpf: logado.data.cpf,
            whatsapp: updatedFields.whatsapp,
          };

          store.commit("incrementLogado", logado);
          this.edit = [false, false, false, false, false, false];
        }
      });
    },
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    if (this.selectedPedidos == "Em Andamento") {
      this.manipulateDataEmAndamento();
    }
    setTimeout(() => {
      this.registroEdit = JSON.parse(JSON.stringify(this.logado.data));
      if (
        this.logado.message != "sucess" &&
        this.logado.message != "Usuário Logado com sucesso."
      ) {
        this.$router.push("/");
      }
    }, 100);
  },

  activated() {},
};
</script>
<style lang="scss" scoped>
.powered-by {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: auto;
  padding: -8px;
}
</style>
